// src/components/RatingStars.jsx

import React from "react";
import { Star } from 'lucide-react';
import { PRIMARY_COLOR } from "../App";

const RatingStars = () => {
  return (
    <div className="flex items-center space-x-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className={`w-4 h-4 fill-yellow-400 ${PRIMARY_COLOR}`} />
      ))}
    </div>
  );
};

export default RatingStars;
